import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';
import _ from 'lodash';

import * as graphql from 'generated/graphql';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';

import FeedbackComposerGoalCard from './FeedbackComposerGoalCard';
import { Subheading } from '@treams/treams-ui';

export default function FeedbackComposerGoals(props: {
	userID: string;
	goals: { goalID: string; text?: string; order: number }[];
	onChange: (goals: { goalID: string; text?: string; order: number }[]) => void;
}) {
	const { t } = useTranslation();

	// TODO: Use pagination?
	const active = graphql.useIndividualGoalsQuery({
		variables: {
			id: props.userID,
			status: graphql.GoalStatus.Active,
			last: 10,
		},
	});

	const completed = graphql.useIndividualGoalsQuery({
		variables: {
			id: props.userID,
			status: graphql.GoalStatus.Completed,
			last: 10,
		},
	});

	return (
		<Box>
			<Box pt={3} pb={2}>
				<Subheading>{t('feedback.composer.goals.title')}</Subheading>
			</Box>
			<HorizontalRule />
			{active.data ? (
				<Box>
					{_.sortBy(active.data.user.goalsV2.edges, ({ node: goal }) => -goal.order).map(({ node: goal }) => (
						<FeedbackComposerGoalCard
							key={goal.id}
							goal={goal as graphql.Goal}
							text={props.goals.find(({ goalID }) => goal.id === goalID)?.text}
							selected={props.goals.some(({ goalID }) => goal.id === goalID)}
							onChange={(selected, text) => {
								const goals = props.goals.filter(({ goalID }) => goalID !== goal.id);

								if (selected) {
									goals.push({ goalID: goal.id, text, order: goal.order });
								}

								props.onChange(_.sortBy(goals, (goal) => -goal.order));
							}}
						/>
					))}
				</Box>
			) : (
				<Box>
					<Spinner isLoading size="18px" />
				</Box>
			)}
			<Box mt={4}>
				<SectionTitle>{t('feedback.composer.goals.completed')}</SectionTitle>
				{completed.data ? (
					<Box>
						{_.sortBy(completed.data.user.goalsV2.edges, ({ node: goal }) => -goal.order).map(({ node: goal }) => (
							<FeedbackComposerGoalCard
								key={goal.id}
								goal={goal as graphql.Goal}
								text={props.goals.find(({ goalID }) => goal.id === goalID)?.text}
								selected={props.goals.some(({ goalID }) => goal.id === goalID)}
								onChange={(selected, text) => {
									const goals = props.goals.filter(({ goalID }) => goalID !== goal.id);

									if (selected) {
										goals.push({ goalID: goal.id, text, order: goal.order });
									}

									props.onChange(_.sortBy(goals, (goal) => -goal.order));
								}}
							/>
						))}
					</Box>
				) : (
					<Box>
						<Spinner isLoading size="18px" />
					</Box>
				)}
			</Box>
		</Box>
	);
}
